import { getPlatformIcons } from '@intelligence/utils/common';
import { GSD_METRIC_KEY_MAP, GSD_CASCADER_METRICS } from '@intelligence/_config/sourceMetric';

const SHARED_BACKEND_METRICS = {
  mscience: ['digitalRevenue', 'units', 'digitalARPPU', 'ast'],
  newzoo: ['lifetime_player', 'mau', 'mau_growth', 'mau_new', 'mau_returning'],
  newzoo_weight: [
    'acquisition',
    'avg_daily_playtime',
    'avg_daily_sessions',
    'avg_playtime_per_session',
    'avg_monthly_sessions',
    'churn',
    'acquisition_number',
    'time_spent_1H',
    'time_spent_5H',
    'time_spent_10H',
    'time_spent_25H',
    'time_spent_50H',
    'retention_d1',
    'retention_d2',
    'retention_d4',
    'retention_d7',
    'retention_d14',
    'retention_d28',
    'avg_monthly_playtime',
    'time_spent_0H',
    'avg_days_played',
    'stickiness',
    'total_hours',
    'player_share',
  ],
};
const GSDValues = [
  GSD_METRIC_KEY_MAP.DIGITAL_UNITS,
  GSD_METRIC_KEY_MAP.PHYSICAL_UNITS,
  GSD_METRIC_KEY_MAP.DIGITAL_REVENUE,
  GSD_METRIC_KEY_MAP.PHYSICAL_REVENUE,
];
// 数据源指标配置，接口入参用
export const DATASOURCE_METRICS_BACKEND_PC: { [key: string]: string[] } = {
  source_steam: ['source_steam__pcu', 'source_steam__acu'],
  steamcharts: ['pcu', 'acu'],
  npd: ['revenue', 'physical_units'],
  vginsights: [
    'est_revenue',
    'est_units',
    'est_price_time',
    'est_price',
    // 'steamfollowers',
    'steamreviews',
  ],
  gamalytic: [
    'gamalytic__pcu',
    'gamalytic__acu',
    'gamalytic__est_revenue',
    'gamalytic__est_units',
    'gamalytic__est_price_time',
    'gamalytic__est_price',
    'gamalytic__steamfollowers',
    'gamalytic__steamreviews',
  ],
  alinea: [
    'alinea__pcu',
    'alinea__acu',
    'alinea__est_revenue',
    'alinea__est_units',
    'alinea__est_price_time',
    'alinea__est_price',
    'alinea__steamfollowers',
    'alinea__steamreviews',
  ],
  ...SHARED_BACKEND_METRICS,
  gsd: GSDValues,
};

// 数据源指标配置，接口入参用
export const DATASOURCE_METRICS_BACKEND_CONSOLE: { [key: string]: string[] } = {
  npd: ['revenue', 'physical_units'],
  ...SHARED_BACKEND_METRICS,
  gsd: GSDValues,
};

const SHARED_METRICS_VALUE = [
  ['Mscience', 'digitalRevenue'],
  ['Mscience', 'units'],
  ['Mscience', 'ast'],
  ...GSD_CASCADER_METRICS,
  ['npd', 'revenue'],
  ['npd', 'physical_units'],
  ['newzoo', 'mau'],
  ['newzoo', 'player_share'],
  ['newzoo', 'mau_growth'],
  ['newzoo', 'mau_new'],
  ['newzoo', 'mau_returning'],
  ['newzoo', 'lifetime_player'],
  ['newzoo', 'time_spent_0H'],
  ['newzoo', 'time_spent_1H'],
  ['newzoo', 'time_spent_5H'],
  ['newzoo', 'time_spent_10H'],
  ['newzoo', 'time_spent_25H'],
  ['newzoo', 'time_spent_50H'],
  ['newzoo', 'avg_daily_playtime'],
  ['newzoo', 'avg_daily_sessions'],
  ['newzoo', 'avg_playtime_per_session'],
  ['newzoo', 'avg_monthly_playtime'],
  ['newzoo', 'avg_monthly_sessions'],
  ['newzoo', 'avg_days_played'],
  ['newzoo', 'stickiness'],
  ['newzoo', 'total_hours'],
  ['newzoo', 'churn'],
  ['newzoo', 'acquisition'],
  ['newzoo', 'retention_d1'],
  ['newzoo', 'retention_d2'],
  ['newzoo', 'retention_d4'],
  ['newzoo', 'retention_d7'],
  ['newzoo', 'retention_d14'],
  ['newzoo', 'retention_d28'],
];
export const DATASOURCE_METRICS_VALUE_PC = [
  ['steam', 'source_steam__pcu'],
  ['steam', 'source_steam__acu'],
  ['steam', 'steamfollowers'],
  ...SHARED_METRICS_VALUE,
];

export const DATASOURCE_METRICS_VALUE_CONSOLE = [...SHARED_METRICS_VALUE];

export const pcuSEGMENT: { [key: string]: any } = {
  pcu: 'PCU',
  acu: 'ACU',
  revenue: 'Physical Revenue',
} as any;

export const PCCONSOLE_DEVICE_COMBILE = {
  PlayStation: ['PlayStation 4', 'PlayStation 5'],
  Xbox: ['Xbox One', 'Xbox Series X|S'],
  Nintendo: ['Nintendo Wii U', 'Nintendo Switch'],
} as any;

export const PCCONSOLE_DEVICE_MAP_COMBINE: {
  [key: string]: string;
} = Object.entries(PCCONSOLE_DEVICE_COMBILE).reduce((current, next) => {
  const [key, value] = next || [];
  const result: {
    [key: string]: string;
  } = {
    ...current,
    [key]: key,
  };
  if (!Array.isArray(value)) return result;
  value?.forEach((item) => {
    result[item] = key;
  });
  return result;
}, {});

// 所有console的devices（聚合格式的）
export const CONSOLE_AGGREGATED_DEVICES = ['PlayStation', 'Xbox', 'Nintendo'];

export const METRICTABLE_DEVICES = [
  { value: 'PC', text: 'PC', icon: getPlatformIcons('pc') },
  { value: 'PlayStation', text: 'PlayStation', icon: getPlatformIcons('playstation') },
  { value: 'Xbox', text: 'Xbox', icon: getPlatformIcons('xbox') },
  { value: 'Nintendo', text: 'Nintendo', icon: getPlatformIcons('nintendo') },
];

export const CONSOLE_DIGITAL_REVENUE_DEVICES = [
  { value: 'PlayStation', text: 'PlayStation' },
  { value: 'Xbox', text: 'Xbox' },
  { value: 'Nintendo', text: 'Nintendo' },
];

export const CONSOLE_MAU_AND_LIFETIMEPLAYERS_DEVICES = [
  { value: 'PlayStation 4', text: 'PlayStation 4' },
  { value: 'PlayStation 5', text: 'PlayStation 5' },
  { value: 'Xbox One', text: 'Xbox One' },
  { value: 'Xbox Series X|S', text: 'Xbox Series X|S' },
];

export const CONSOLE_AMPERE_PLATFORM = [
  // PC 文案参数传 Steam
  { value: 'PC', text: 'PC(Steam)' },
  { value: 'PlayStation 4', text: 'PlayStation 4' },
  { value: 'PlayStation 5', text: 'PlayStation 5' },
  { value: 'Xbox One', text: 'Xbox One' },
  // Xbox Series X|S 文案参数传 Xbox Series
  { value: 'Xbox Series', text: 'Xbox Series X|S' },
];

/**
 * 需要将 countries user engagement 传入的参数展示时映射为正常展示的文案
 * Steam -> PC(Steam)、Xbox Series -> Xbox Series X|S
 */
export const CONSOLE_AMPERE_PLATFORM_TEXT_MAP: Record<string, string> = {
  Steam: 'PC(Steam)',
  'PlayStation 4': 'PlayStation 4',
  'PlayStation 5': 'PlayStation 5',
  'Xbox One': 'Xbox One',
  'Xbox Series': 'Xbox Series X|S',
};

export const CONSOLE_PHYSICAL_REVENUE_DEVICES = [
  { value: 'PlayStation 4', text: 'PlayStation 4' },
  { value: 'PlayStation 5', text: 'PlayStation 5' },
  { value: 'Xbox One', text: 'Xbox One' },
  { value: 'Xbox Series X|S', text: 'Xbox Series X|S' },
  { value: 'Nintendo Wii U', text: 'Nintendo Wii U' },
  { value: 'Nintendo Switch', text: 'Nintendo Switch' },
];

export const CONSOLE_JAPAN_SALES_DEVICES = [
  { value: 'ps4', text: 'PlayStation 4' },
  { value: 'ps5', text: 'PlayStation 5' },
  { value: 'switch', text: 'Nintendo Switch' },
];

export const METRICTABLE_KPITRENDS_WEEK_DEVICES = [
  { value: 'PC', text: 'PC', icon: getPlatformIcons('pc') },
  { value: 'PlayStation 4', text: 'PlayStation 4', icon: getPlatformIcons('PlayStation') },
  { value: 'PlayStation 5', text: 'PlayStation 5', icon: getPlatformIcons('PlayStation') },
  { value: 'Xbox One', text: 'Xbox One', icon: getPlatformIcons('xbox') },
  { value: 'Xbox Series X|S', text: 'Xbox Series X|S', icon: getPlatformIcons('xbox') },
  { value: 'Nintendo Wii U', text: 'Nintendo Wii U', icon: getPlatformIcons('nintendo') },
  { value: 'Nintendo Switch', text: 'Nintendo Switch', icon: getPlatformIcons('nintendo') },
];

// pc console游戏详情下载切换为榜单下载接口，添加参数
export const PcConsoleNewParams = {
  genre_source: 'iegg',
  iegg_genre_req: [],
  company: [],
  start_release_time: '',
  end_release_time: '',
  order: 'desc',
  order_metric: 'pcu',
  order_source: 'steamcharts',
  ratio_type: 0,
  search_by_name: '',
  data_method: '',
  page: 1,
  page_size: 100,
  company_show: 0,
  genre_show: 0,
  release_date_show: 0,
  region_show: 0,
  platform: ['facebook', 'ytg', 'twitch'],
  file_name: '',
  device: [],
  // select_top: 0,
  // segment: "Base Game",
};

// 需要展示最早可视化提示文案的时间组件快捷类型
export const RELEASE_DATE_SHORTCUT = [
  'Since Release',
  'Earliest Data',
  'First Year Since Release',
  'First Month Since Release',
  'All of time',
];
